const fields = [
  {
    dataIndex: 'index',
    key: 'index',
    title: '序号',
    width: 80,
    scopedSlots: {
      customRender: 'subscript'
    }
  },
  {
    dataIndex: 'name',
    key: 'name',
    title: '专家姓名',
    scopedSlots: {
      customRender: 'TextAction'
    }
  },
  {
    dataIndex: 'industryStr',
    key: 'industry',
    title: '行业',
    width: 100
  },
  {
    dataIndex: 'publishTime',
    key: 'publishTime',
    title: '发布日期',
    width: 120
  },
  // {
  //   dataIndex: 'createTime',
  //   key: 'createTime',
  //   title: '创建日期',
  //   width: 120
  // },
  {
    dataIndex: 'statusStr',
    key: 'status',
    width: 90,
    scopedSlots: {
      customRender: 'color'
    },
    title: '状态'
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action'
    }
  }
]

const formRow = [
  {
    span: 12,
    label: '姓名',
    component: 'AInput',
    placeholder: '请输入名称',
    prop: 'name',
    allowClear: true
  },
  {
    span: 7,
    label: '行业',
    component: 'ASelect',
    prop: 'industry',
    placeholder: '选择行业',
    allowClear: true,
    list: [
      { label: '代理服务', value: '1' },
      { label: '法律服务', value: '2' },
      { label: '咨询服务', value: '3' },
      { label: '信息服务', value: '4' },
      { label: '企业管理', value: '5' }
    ]
  }
]

const slotOpt = [
  {
    slot: 'TextAction',
    component: 'TextAction',
    cb: 'toDetail'
  },
  {
    slot: 'action',
    component: 'Action',
    list: [
      { name: '编辑', cb: 'edit' },
      // { name: '发布', cb: 'issue', divider: true },
      { name: '删除', cb: 'singleDelete', divider: true }
    ]
  }
]

module.exports = {
  fields,
  slotOpt,
  formRow
}
